import type { ApiIoValidation, ApiOpportunityStatus, IoValidationStatus } from './types';

const POLL_DELAYS_MS = [2000, 4000, 8000, 16000, 30000] as const;

// Stop polling after this many attempts. Otherwise a validation job that dies before the
// backend reconcile sweep flips it to ERROR would make the merchant's tab hit the API every
// 30s forever. With the delay schedule above this cap is ~18 minutes — well beyond a real check.
export const MAX_IO_VALIDATION_POLLS = 40;

export function getIoValidationPollDelay(attempt: number): number | false {
  if (attempt >= MAX_IO_VALIDATION_POLLS) return false;
  const lastDelayIndex = POLL_DELAYS_MS.length - 1;
  const delayIndex = Math.min(Math.max(attempt, 0), lastDelayIndex);
  return POLL_DELAYS_MS[delayIndex];
}

export function getIoValidationFailureMessages(ioValidation?: ApiIoValidation): string[] {
  const messages = (ioValidation?.failureReasons ?? [])
    .map((reason) => (typeof reason === 'string' ? reason : reason.message).trim())
    .filter(Boolean);
  return Array.from(new Set(messages));
}

export function shouldPollIoValidation(apiStatus?: ApiOpportunityStatus, ioValidation?: ApiIoValidation): boolean {
  return shouldPollIoValidationStatus(apiStatus, ioValidation?.status);
}

export function shouldPollIoValidationStatus(apiStatus?: string, validationStatus?: IoValidationStatus): boolean {
  if (apiStatus === 'PENDING_CHECK') return validationStatus !== 'ERROR';
  // Once the group has left PENDING_CHECK the validation verdict is what moved it, so a
  // still-"PENDING" validation object here is stale (cache/race). Stop polling and let a normal
  // refetch reconcile it, rather than keeping the merchant's tab polling on stale data.
  return false;
}
